export default "__VITE_ASSET__DiJirCLv__"